/* eslint-disable @typescript-eslint/no-duplicate-enum-values */
export enum ActivationStatus {
    ACTIVE = 'ACTIVE',
    FAILED = 'FAILED',
    RFA = 'READY_FOR_ACTIVATION',
    NEW_IN_PROGRESS = 'NEW_LINE_IN_PROGRESS',
    PORT_IN_PROGRESS = 'PORT_IN_PROGRESS',
    PENDING = 'PENDING',
    NOT_ACTIVATED = 'NOT_ACTIVATED',
    RESOLUTION_REQUIRED = 'RESOLUTION_REQUIRED',
    UNKNOWN = 'UNKNOWN'
}

export enum ActivationRequestIntervals {
    requestInterval = 10000,
    longRequestInterval = 60000,
    longDelayStop = 60
}

export enum SimPairingRequestInterval {
    requestInterval = 5000,
    requestTimeout = 20000,
    pollingCounter = 5
}

export enum OrderStatus {
    SUBMITTED = 'SUBMITTED',
    COMPLETED = 'COMPLETED',
    CANCELLED = 'CANCELLED'
}

export enum FraudStatus {
    IN_REVIEW = 'IN_REVIEW',
    PASSED = 'PASSED',
    FAILED = 'FAILED'
}

export enum RetryPaymentCode {
    SUCCESS = 'SUCCESS',
    FAILED = 'FAILED',
    BILL_PAYMENT_FAILED = 'BILL_PAYMENT_FAILED',
    ORDER_PAYMENT_FAILED = 'ORDER_PAYMENT_FAILED',
    DEFAULT_INSTRUMENT_FAILED = 'DEFAULT_INSTRUMENT_FAILED',
    DELETE_TOKEN_FAILED = 'DELETE_TOKEN_FAILED',
    UPDATE_PAYMENT_INSTRUMENT_FAILED = 'UPDATE_PAYMENT_INSTRUMENT_FAILED',
    UPDATE_EXPIRYDATE_FAILED = 'UPDATE_EXPIRYDATE_FAILED'
}

export enum ShipmentStatus {
    PLANNED = 'PLANNED',
    SHIPPED = 'SHIPPED',
    DELIVERED = 'DELIVERED',
    DELIVERY_FAILED = 'DELIVERY_FAILED'
}

export enum ActivationType {
    NEW = 'NEW',
    PORT_IN = 'PORT_IN',
    NDEL = 'NDEL'
}

export enum ActivationVerificationStatus {
    NOT_STARTED = 'NOT_STARTED',
    PENDING = 'PENDING',
    VERIFIED = 'VERIFIED',
    EXPIRED = 'EXPIRED',
    FAILED = 'FAILED',
    LOCKED = 'LOCKED',
    RETRY = 'RETRY'
}

export enum CarrierWarningRadioButton {
    YES = 'YES',
    NO = 'NO'
}

export enum CreditCardMethodRadioButton {
    EXISTING_CARD = 'EXISTING_CARD',
    NEW_CARD = 'NEW_CARD'
}

export enum ActivationError {
    ERROR8A = 'R678',
    ERROR8B = 'R679',
    ERROR8C = 'R680',
    ERROR8D = 'R681',
    ERROR8E = 'R682',
    ERROR8F = 'R683',
    ACCOUNT_NUMBER_VALIDATION_ERROR = 'R111',
    NUMBER_TRANSFER_PIN_ERROR = 'R671',
    PORT_PROTECTION_A = 'R615',
    PORT_PROTECTION_B = 'R616',
    PORT_PROTECTION_C = 'R621',
    PORT_PROTECTION_D = 'R623',
    PORT_PROTECTION_E = 'R657',
    PORT_PROTECTION_F = 'R660',
    PHONE_NUMBER = 'R661',
    PORT_PROTECTION_G = 'R667'
}

export enum ActivationErrorMapping {
    ERROR8A = 'accountNumber',
    ERROR8B = 'ssn',
    ERROR8C = 'accountPin',
    ERROR8D = 'zipCode',
    ERROR8E = 'firstName',
    ERROR8F = 'lastName',
    ACCOUNT_NUMBER_VALIDATION_ERROR = 'accountNumber',
    NUMBER_TRANSFER_PIN_ERROR = 'numberTransferPin',
    PORT_PROTECTION_A = 'portProtectionA',
    PORT_PROTECTION_B = 'portProtectionB',
    PORT_PROTECTION_C = 'portProtectionC',
    PORT_PROTECTION_D = 'portProtectionD',
    PORT_PROTECTION_E = 'portProtectionE',
    PORT_PROTECTION_F = 'portProtectionF',
    PORT_PROTECTION_G = 'portProtectionG',
    PHONE_NUMBER = 'phoneNumber'
}

export enum LineStatus {
    ACTIVE = 'ACTIVE',
    SUSPENDED = 'SUSPENDED',
    PENDING = 'PENDING',
    PENDING_CANCEL = 'PENDING_CANCEL',
    DEACTIVATED = 'DEACTIVATED',
    READY_FOR_ACTIVATION = 'READY_FOR_ACTIVATION',
    PAUSED_FOR_DEPLOYMENT = 'PAUSED_FOR_DEPLOYMENT'
}

export enum ProvisioningStatus {
    ACTIVE = 'ACTIVE',
    SUSPENDED = 'SUSPENDED',
    PENDING = 'PENDING',
    DEACTIVATED = 'DEACTIVATED'
}

export enum LineStatusDisplay {
    SUSPENDED = 'Suspended',
    PENDING = 'Not activated',
    DEACTIVATED = 'Deactivated'
}

export enum DeviceStatus {
    ACTIVE = 'ACTIVE',
    NDEL = 'NDEL',
    DPP_OUTSTANDING = 'DPP_OUTSTANDING',
    PENDING = 'PENDING',
    EXCHANGE = 'EXCHANGE',
    WARRANTY = 'WARRANTY',
    INSURANCE = 'INSURANCE',
    UPGRADE = 'UPGRADE',
    BYOD_EXCHANGE = 'BYOD_EXCHANGE',
    NEW_SIM = 'NEWSIM'
}

export enum SimType {
    ESIM = 'ESIM',
    PSIM = 'PSIM',
    PSIM_ESIM = 'PSIM_ESIM',
    ESIM_PSIM = 'ESIM_PSIM'
}

export enum DeviceNetworkCompatibilityStatus {
    COMPATIBLE = 'COMPATIBLE',
    NOT_COMPATIBLE = 'NOT_COMPATIBLE'
}

export enum NetworkDeviceStatus {
    ACTIVE = 'ACTIVE',
    NDEL = 'NDEL',
    DPP_OUTSTANDING = 'DPP_OUTSTANDING',
    PENDING = 'PENDING',
    NEWSIM = 'NEWSIM',
    EXCHANGE = 'EXCHANGE',
    WARRANTY = 'WARRANTY',
    INSURANCE = 'INSURANCE',
    UPGRADE = 'UPGRADE',
    DEFERRED_PORTIN = 'DEFERRED_PORTIN'
}

export enum ActivityOptions {
    CALLS = 'calls',
    MEX_CAN_CALLS = 'calls-to-mex-can',
    CALLS_TO_NON_US_NUMBER = 'calls-to-non-us-numbers',
    CALLS_WHILE_OUTSIDE_US = 'calls-while-outside-us',
    MESSAGES = 'messages',
    MESSAGES_WHILE_OUTSIDE_US = 'messages-while-outside-us',
    MESSAGES_TO_NON_US_NUMBER = 'messages-to-non-us-numbers',
    DATA_WHILE_OUTSIDE_US = 'data-while-outside-us',
    GLOBAL_TRAVEL_PASS = 'global-travel-pass',
    MEX_CAN_TRAVEL_PASS = 'mex-can-travel-pass'
}

export enum MessageType {
    TEXT = 'TEXT',
    MMS = 'MMS'
}

export enum LogDirection {
    INCOMING = 'INCOMING',
    OUTGOING = 'OUTGOING'
}

export enum TransactionType {
    BALANCE_PAYMENT = 'BALANCE_PAYMENT',
    STATEMENT = 'STATEMENT',
    ADDITIONAL_DEVICE_PAYMENT = 'ADDITIONAL_DEVICE_PAYMENT',
    REFUND = 'REFUND',
    CREDIT = 'CREDIT',
    ORDER = 'ORDER',
    PREORDER = 'PREORDER',
    BACKORDER = 'BACKORDER',
    UPGRADE_ORDER = 'UPGRADE',
    RETURN_ORDER = 'RETURN',
    CREDIT_REVERSAL = 'CREDIT_REVERSAL',
    EXCHANGE_ORDER = 'EXCHANGE',
    WARRANTY_EXCHANGE_ORDER = 'WARRANTY_EXCHANGE_ORDER',
    ONETIME_PAYMENT = 'ONETIME_PAYMENT',
    QUICK_PAYMENT = 'QUICK_PAYMENT',
    DEFAULT = 'DEFAULT'
}

export enum StatementRouteParam {
    PAID = 'paid',
    PENDING = 'pending',
    ESTIMATED = 'estimated',
    PAST_DUE = 'past_due',
    PENDING_WITH_CREDIT = 'pending-with-credit'
}

export enum PaymentState {
    PENDING = 'PENDING',
    PAID = 'PAID',
    PAST_DUE = 'PAST_DUE',
    ESTIMATED = 'ESTIMATED'
}

export enum TransactionCount {
    SINGLE = 'SINGLE',
    MULTIPLE = 'MULTIPLE'
}

export enum ChargeType {
    DOWN_PAYMENT = 'DOWN_PAYMENT',
    LINE_SERVICE_PRIMARY = 'LINE_SERVICE_PRIMARY',
    DEVICE_FINANCED = 'DEVICE_FINANCED',
    DEVICE_PURCHASED = 'DEVICE_PURCHASED',
    INSURANCE_PLAN = 'INSURANCE_PLAN',
    XMC_INCLUDED = 'XMC_INCLUDED',
    NO_WIRELINE_SURCHARGE = 'NO_WIRELINE_SURCHARGE',
    DOMESTIC_CHARGE = 'DOMESTIC_CHARGE',
    INTERNATIONAL_CHARGE = 'INTERNATIONAL_CHARGE',
    ROAMING_CHARGE = 'ROAMING_CHARGE',
    ACCESSORY = 'ACCESSORY',
    HD_PASS = 'HD_PASS',
    MEX_CAN_PASS = 'MEX_CAN_PASS',
    DEVICE_SUBSIDY = 'DEVICE_SUBSIDY',
    DEVICE_ACCESS_FEE = 'DEVICE_ACCESS_FEE',
    EWASTE_FEE = 'EWASTE_FEE',
    GLOBAL_TRAVEL_PASS = 'GLOBAL_TRAVEL_PASS',
    GTP = 'GTP',
    CANMEX_UNLIMITED_PASS = 'CANMEX_UNLIMITED_PASS',
    DATA_ROAMING = 'DATA_ROAMING',
    MEX_CAN_TRAVEL_PASS = 'CANMEX_TRAVEL_PASS',
    ACTIVATION_FEE = 'ACTIVATION_FEE',
    ACTIVATION_FEE_DISCOUNT = 'ACTIVATION_FEE_DISCOUNT',
    TIP = 'TIP',
    TRADEIN_PROMO_DDA = 'TRADEIN_PROMO_DDA',
    SERVICE_PROMO_LINE = 'SERVICE_PROMO_LINE',
    SERVICE_PROMO = 'SERVICE_PROMO',
    MEX_CAN_UNL = 'MEX_CAN_UNL',
    GTP_INCL = 'GTP_INCL',
    XMC_PROMO = 'XMC_PROMO',
    GLOBAL_TRAVEL_ADDITIONAL_PASS = 'GLOBAL_TRAVEL_ADDITIONAL_PASS',
    CANMEX_UNL_ADDITIONAL_PASS = 'CANMEX_UNL_ADDITIONAL_PASS',
    DELIVERY_FEE = 'DELIVERY_FEE',
    CBE_FEE = 'CBE_FEE'
}

export enum ChargePlanGroup {
    ACP = 'ACP',
    XMCP_CBM = 'Xfinity Mobile Care Plus - CBM'
}

export enum OrderItemCategory {
    TABLET = 'TABLET',
    PHONE = 'PHONE',
    ACCESSORY = 'ACCESSORY',
    SMART_WATCH = 'SMART_WATCH'
}

export enum DeviceType {
    TABLET = 'TABLET',
    DEVICE = 'DEVICE',
    PHONE = 'PHONE',
    SMART_WATCH = 'SMART_WATCH'
}

export enum UpgradeDeviceType {
    PHONE = 'cell-phones',
    TABLET = 'tablets',
    SMART_WATCH = 'smart-watches'
}

export enum UserState {
    ACTIVE = 'ACTIVE',
    INACTIVE = 'INACTIVE',
    NON_PAY_SUSPENDED = 'NON_PAY_SUSPENDED',
    NOT_SUBSCRIBED = 'NOT_SUBSCRIBED',
    CLOSED = 'CLOSED',
    HOTLINED = 'HOTLINED'
}

export enum UserRoles {
    MANAGER = 'MANAGER',
    MEMBER = 'MEMBER',
    PRIMARY = 'PRIMARY',
    VIEWER = 'VIEWER',
    OWNER = 'OWNER'
}

export enum UserErrorType {
    NOT_USER = 'non-user',
    SECONDARY_USER = 'secondary-user',
    XMB_COMING_SOON = 'xmb-coming-soon',
    NO_LINES = 'no-lines'
}

export enum SalesChannel {
    ONLINE = 'ONLINE',
    RETAIL = 'RETAIL',
    TELESALES = 'TELESALES'
}

export enum TaxFeeCategory {
    TAX = 'TAX',
    COMCAST = 'COMCAST',
    FEE = 'FEE'
}

export enum TaxType {
    DEVICE = 'DEVICE',
    ACP = 'ACP'
}

export const APPLECARE_SALES_TAX: string = 'AppleCare+ Sales Tax';


export enum ReturnEligible {
    ELIGIBLE = 'ELIGIBLE',
    GRACE = 'GRACE',
    INELIGIBLE = 'INELIGIBLE'
}

export enum OrderItemType {
    PREORDER = 'PREORDER',
    BACKORDER = 'BACKORDER',
    REGULAR = 'REGULAR',
    RETURN = 'RETURN',
    EXCHANGE = 'EXCHANGE',
    WARRANTY_EXCHANGE = 'WARRANTY_EXCHANGE',
    UPGRADE = 'UPGRADE',
    UPGRADE_PREORDER = 'UPGRADE_PREORDER',
    UPGRADE_BACKORDER = 'UPGRADE_BACKORDER',
    NDEL = 'NDEL',
    NDEL_PREORDER = 'NDEL_PREORDER',
    NDEL_BACKORDER = 'NDEL_BACKORDER',
    SIMLED_BYOD = 'SIMLED_BYOD',
    CHANGE_ESIM = 'CHANGE_ESIM',
    CHANGE_SEGMENT = 'CHANGE_SEGMENT',
    CHANGE_PLAN = 'CHANGE_PLAN',
    SALES = 'SALES',
    CHANGE = 'CHANGE',
    SEGMENT_SWITCH = 'SEGMENT_SWITCH',
    CEASE = 'CEASE'
}

export enum ReturnStatus {
    SUBMITTED = 'SUBMITTED',
    RECEIVED = 'RECEIVED',
    GRADED = 'GRADED',
    REFUNDED = 'REFUNDED',
    CHARGED = 'CHARGED',
    CANCELLED = 'CANCELLED'
}

export enum ReturnFeeCategory {
    DAMAGE = 'DAMAGE',
    RESTOCKING = 'RESTOCKING'
}

export enum PaymentCaptureStatus {
    SUCCESS = 'SUCCESS',
    FAIL = 'FAIL'
}

export enum StatementSummaryId {
    PAID = 'statement.paid',
    ESTIMATED = 'statement.estimated',
    NEXT = 'statement.next',
    NEXT_WITH_CREDIT = 'statement.nextWithCredit',
    PAST_DUE = 'statement.pastDue'
}

export enum PromoDescription {
    DEVICE_CREDIT_FOR_TABLET_AND_WATCH = 'All-in Tablet & Watch Plan Credit',
    MULTI_PRODUCT_DISCOUNT = 'Multi-product discount',
    MOBILE_LINE_DISCOUNT = 'Mobile Line Discount',
    UNLIMITED_LINE_DISCOUNT = 'Unlimited line discount'
}


export enum CBMGeminiPromoIds {
    LINE_DISCOUNT = '33540074',
    FOUR_PLUS_LINE_PROMO = 'GEMTIERPROMO'
}

export const CBMGeminiPromoIdValues: string[] = Object.values(CBMGeminiPromoIds);

export enum DeviceBridgeId {
    ACTIONABLE_ERROR = 'device.actionableError',
    OTHER_ERROR = 'device.otherError',
    ACTIVATION_IN_PROGRESS = 'device.activationInProgress',
    READY_FOR_ACTIVATION = 'device.readyForActivation',
    SHIPPED = 'device.shipped',
    XMPP = 'device.xmpp',
    BYOD_RFA = 'device.byodReadyForActivation',
    BYOD_SHIPPED = 'device.byodShipped',
    WATCH_RFA = 'device.watchReadyForActivation',
    SEGMENT_SWITCH = 'device.segmentSwitch',
    DEVICE_SIM_ALIGNEMNT = 'device.simalignment',
    BYOD_SIMLED = 'device.byodSimled',
    DEVICE_TRADE_IN = 'device.tradeIn',
    DEVICE_TRADE_IN_PLUSUP = 'device.tradeInPlusUp',
    DEVICE_TRADE_IN_NOPLUSUP = 'device.tradeInNoPlusUp',
    BYOD_EXCHANGE_FAILED = 'device.byodExchangeReadyForActivation',
    BYOD_EXCHANGE_PENDING = 'device.byodExchangePending',
    BYOD_EXCHANGE_RFA = 'device.byodExchangeReadyForActivation',
    DEVICE_LINE_TRANSFER = 'device.lineTransfer',
    ESIM_RFA = 'device.esimReadyForActivation',
    ESIM_RFA_CBM = 'cb.device.esimReadyForActivation',
    BYOD_NDEL_RFA = 'device.byodNdelReadyForActivation',
    TIP_SEND_DEVICE = 'device.tipSendDevice',
    DEVICE_FIND_MY_PHONE = 'device.findMyPhone',
    SEND_EARLY_UPGRADE_DEVICE = 'device.sendEarlyUpgradeDevice',
    NEW_SIM = 'device.newSim',
    NEW_SIM_CBM = 'device.newSimCBM',
    EARLY_UPGRADE_ELIGIBLE_WITHOUT_FEE = 'device.eligibleEarlyUpgradeWithoutFee',
    EARLY_UPGRADE_ELIGIBLE_WITH_FEE = 'device.eligibleEarlyUpgradeWithFee',
    EARLY_UPGRADE_ELIGIBLE_WITH_DEVICE_PAYMENT_AND_WITH_FEE = 'device.eligibleEarlyUpgradeWithDevicePaymentAndWithFee',
    EARLY_UPGRADE_ELIGIBLE_WITH_DEVICE_PAYMENT_AND_WITHOUT_FEE = 'device.eligibleEarlyUpgradeWithDevicePaymentAndWithoutFee',
    ANYTIME_UPGRADE = 'device.anytimeUpgrade',
    ANYTIME_UPGRADE_NOT_PIF = 'device.anytimeUpgradeNotPaidInFull',
    UPGRADE_ELIGIBLE = 'device.eligibleUpgrade',
    UPGRADE_ELIGIBLE_NY_USERS = 'device.upgradeEligibleForNYUsers',
    ACTIVATION_DIRECTED_TO_APP = 'device.activationDirectedToApp',
    VIEW_INSURANCE_DETAILS = 'device.insurancePlanDetails',
    VIEW_INSURANCE_DETAILS_CB = 'device.insurancePlanDetailsCB',
    VIEW_XMC_PLAN_INSURANCE_DETAILS = 'device.viewXMCPlanInsuranceDetails',
    VIEW_XMC_PLUS_PLAN_INSURANCE_DETAILS = 'device.viewXMCPlusPlanInsuranceDetails',
    NUMBER_LOCK_WITH_READY_FOR_ACTIVATION = 'device.numberLockWithReadyForActivation',
    XFINITY_TOTAL_DEVICE_PROTECTION = 'device.XTDP',
    XFINITY_TOTAL_DEVICE_PROTECTION_PLUS = 'device.XTDPplus',
    XFINITY_MOBILE_CARE = 'device.XMC',
    NUMBER_TRANSFER_AVAILABLE = 'device.numberTransferAvailable',
    NUMBER_TRANSFER_IN_PROGRESS = 'device.numberTransferInProgress',
    NUMBER_TRANSFER_ERROR = 'device.numberTransferError',
    NUMBER_TRANSFER_AVAILABLE_CBM = 'device.numberTransferAvailableCBM',
    NUMBER_TRANSFER_IN_PROGRESS_CBM = 'device.numberTransferInProgressCBM',
    NUMBER_TRANSFER_ERROR_CBM = 'device.numberTransferErrorCBM',
    UPGRADE_ELIGIBLE_TABLETS = 'device.upgradeEligibleForTablets',
    EARLY_UPGRADE_ELIGIBLE_WITH_FEE_FOR_TABLETS = 'device.eligibleEarlyUpgradeWithFeeForTablets',
    EARLY_UPGRADE_ELIGIBLE_WITHOUT_FEE_FOR_TABLETS = 'device.eligibleEarlyUpgradeWithoutFeeForTablets',
    UPGRADE_ELIGIBLE_WATCHES = 'device.upgradeEligibleForWatches',
    EARLY_UPGRADE_ELIGIBLE_WITH_FEE_FOR_WATCHES = 'device.eligibleEarlyUpgradeWithFeeForWatches',
    EARLY_UPGRADE_ELIGIBLE_WITHOUT_FEE_FOR_WATCHES = 'device.eligibleEarlyUpgradeWithoutFeeForWatches'
}

export const ESTIMATED_STATEMENT_ID: string = 'estimated';

export enum ProgressStatus {
    SUMMARY = 'SUMMARY',
    IN_PROGRESS = 'IN_PROGRESS',
    PENDING = 'PENDING',
    SUCCESS = 'SUCCESS',
    FAIL = 'FAILED'
}

// this hero banner list must match exactly as in CMS banner template's Hero banner Ids
export enum Herobanner {
    BY_THE_GIG = 'account.bau.withbtg',
    UNLIMITED = 'account.bau.unlimitedonly',
    PAYMENT_FAILURE = 'account.payment.failure',
    CARD_EXPIRING = 'account.payment.card.expiring',
    ACTIVATION_FAILURE = 'account.activation.failure',
    ORDER_PLACED = 'account.order.placed',
    ORDER_SHIPPED = 'account.order.shipped',
    ORDER_DELIVERED = 'account.order.delivered',
    ORDER_DELIVERED_BYOD = 'account.order.delivered.byodOnly',
    OPTIMIZE_SINGLE = 'account.optimize.single',
    OPTIMIZE_MULTIPLE = 'account.optimize.multi',
    REDUCED_SPEED_SINGLE = 'account.reducedspeed.single',
    REDUCED_SPEED_MULTI = 'account.reducedspeed.multi',
    SEG2_UNLIMITED = 'account.bau.unlimitedonly.seg2',
    SEG2_BY_THE_GIG = 'account.bau.withbtg.seg2',
    SEG2_DATA_SHARED50= 'account.datashared50',
    SEG2_DATA_SHARED80 = 'account.datashared80',
    SEG2_DATA_SHARED100 = 'account.datashared100',
    ERROR = 'account.error'
}

// this Line banner list must match exactly as in CMS banner template's Line banner Ids
export enum LineBanner {
    BY_THE_GIG = 'line.bau.btg',
    UNLIMITED = 'line.bau.unlimited',
    ORDER_PLACED = 'line.order.placed',
    ORDER_SHIPPED = 'line.order.shipped',
    ORDER_DELIVERED = 'line.order.delivered',
    ORDER_DELIVERED_BYOD = 'line.order.delivered.byodOnly',
    OPTIMIZE_SINGLE = 'line.optimize.single',
    ACTIVATION_FAILURE = 'line.activation.failure'
}

export enum RefundRouteParam {
    CREDIT = 'credit',
    REFUND = 'refund',
    CREDIT_REVERSAL = 'credit-reversal'
}

export enum ReturnNextInstructionStep {
    MAIL_STEP = 'MAIL_STEP',
    WATCH_STEP = 'WATCH_STEP',
    REVIEW_STEP = 'REVIEW_STEP',
    REFUND_STEP = 'REFUND_STEP'
}

export enum Carriers {
    VERIZON = 'Verizon'
}

export enum AddonStatus {
    ACTIVE = 'ACTIVE',
    INACTIVE = 'INACTIVE',
    PENDING_REMOVAL = 'PENDING_REMOVAL',
    INCLUDED = 'INCLUDED'
}

export enum AddonPassStatus {
    ACTIVE = 'In use',
    INACTIVE = 'Off',
    PENDING_REMOVAL = 'Pending',
    INCLUDED = 'Included',
    ADD_PENDING = 'Addition Pending',
    REMOVE_PENDING = 'Removal Pending',
    ADDED = 'Added',
    REMOVED = 'Removed'
}

export enum AddonAction {
    ADD = 'ADD',
    add = 'add',
    REMOVE = 'REMOVE',
    remove = 'remove',
    GTP_BOOST = 'GTP_BOOST',
    MEXCAN_BOOST = 'CAN_MEX_UNL_PASS_BOOST'
}


export const AddonGtpPlanCodes: string[] = ['8845346', '8893774', '8895994', '8898874', '8896694', '8881676'];

export const DEFAULT_SUBSIDY_TYPE: string = 'DEFAULT';

export const TRANSACTION_LIST_FIRST_LOAD_LIMIT: number = 5;
export const TRANSACTION_LIST_FIRST_LOAD_LIMIT_FOR_PAID_STATEMENT: number = 6;

export const LINES_LIST_FIRST_LOAD_LIMIT: number = 10;

export const DEVICES_PER_PAGE_LIMIT: number = 6;

export const REQUEST_INTERVAL: number = 8000;

export const PERCENTAGE_UPDATE_INTERVAL: number = 100;

export const RETRY_REQUEST_COUNT: number = 5;

export const REQUEST_TIMEOUT: number = 40000;

export const CANCEL_OTHER_XTIP: string = 'CANCEL_OTHER_XTIP'; 

export const SERVICE_PROMO_ACCOUNT: string = 'SERVICE_PROMO_ACCOUNT';

export const DEFAULT_CARRIER: DropdownItem = {
    label: 'Other / Not Sure',
    value: 'Other/NotSure'
};

export const RETURN_TERMINAL: string = 'RETURN_TERMINAL';

export enum ActivityCodes {
    RETURN = 'RT'
}

export enum DataPlanType {
    UNLIMITED = 'UNLIMITED',
    BY_THE_GIG = 'BY_THE_GIG',
    BY_THE_GIG_SHARED = 'BY_THE_GIG_SHARED',
    SMART_WATCH = 'SMART_WATCH',
    TABLET = 'TABLET'
}

export enum UnlPlanSubgroup {
    BASIC = 'BASIC',
    PLUS = 'PLUS',
    PREMIUM = 'PREMIUM',
    TABLET_PREMIUM = 'TABLET_PREMIUM',
    STANDALONE = 'STANDALONE',
    PRO = 'PRO',
    STANDARD = 'STANDARD',
    SELECT = 'SELECT'
}

export enum GeminiCBMNoLevelSubgroup {  
    PRO = 'PRO',
    STANDARD = 'STANDARD' 
}

export enum PlanEightSubgroup {
    SELECT = 'SELECT',
    PLUS = 'PLUS'
}

export enum XmcPayloadConstants {
    PRIMARY_CHANGE_TYPE = 'CHANGE_PLAN',
    PRIMARY_ACTION = 'CHANGE',
    INSURANCE_CHANGE_TYPE = 'INSURANCE',
    INSURANCE_ACTION = 'ADD'

}

export enum AccountEligibilityStatus {
    ELIGIBLE = 'ELIGIBLE',
    INELIGIBLE_HOTLINED = 'INELIGIBLE_HOTLINED',
    INELIGIBLE_NON_PAY_SUSPEND = 'INELIGIBLE_NON_PAY_SUSPEND'
}

export enum PlanEligibilityStatus {
    ELIGIBLE = 'ELIGIBLE',
    INELIGIBLE_IN_USE = 'INELIGIBLE_IN_USE',
    INELIGIBLE_OVERAGE = 'INELIGIBLE_OVERAGE',
    REQUIRES_UPGRADE = 'REQUIRES_UPGRADE',
    INELIGIBLE_BUCKET = 'INELIGIBLE_BUCKET',
    INELIGIBLE_CHANGE_PENDING = 'INELIGIBLE_CHANGE_PENDING',
    INELIGIBLE_SCHEDULED = 'INELIGIBLE_SCHEDULED'
}

export enum DatasaverStatus {
    INELIGIBLE = 'INELIGIBLE',
    ON = 'ON',
    OFF = 'OFF'
}

export enum GtpPassCountry {
    CANADA = 'CANADA',
    MEXICO = 'MEXICO'
}

export enum DataPlanCodes {
    UNLIMITED_LEVEL2_PHONE = '8727496',
    UNLIMITED_LEVEL2_TABLET = '8731836',

    UNLIMITED_LEVEL3_PHONE_1_LINE = '8854456:1',
    UNLIMITED_LEVEL3_TABLET = '8855146',

    BY_THE_GIG_DEFAULT = 'default',
    UNLIMITED_DEFAULT = 'unlimited_default'

    /*
        Regressive Unlimited Pricing Plan code for Unlimited lines
        Only using RUP_UNLIMITED_1_LINE code as of now

        RUP_UNLIMITED_2_LINE = '8854456:2',
        RUP_UNLIMITED_3_LINE = '8854456:3',
        RUP_UNLIMITED_4_LINE = '8854456:4',
        RUP_UNLIMITED_5_LINE = '8854456:5',
        RUP_UNLIMITED_6_LINE = '8854456:6',
        RUP_UNLIMITED_7_LINE = '8854456:7',
        RUP_UNLIMITED_8_LINE = '8854456:8',
        RUP_UNLIMITED_9_LINE = '8854456:9',
        RUP_UNLIMITED_10_LINE = '8854456:10'
    */
}

export enum AddonType {
    HD_PASS = 'HD_PASS',
    MEX_CAN_PASS = 'MEX_CAN_PASS',
    GTP = 'GTP',
    CAN_MEX_UNL_PASS = 'CAN_MEX_UNL_PASS',
    INTERNATIONAL = 'INTERNATIONAL'
}

export enum AddonRouteType {
    MEX_CAN_PASS = 'mex-can',
    GTP = 'gtp'
}

export enum FindMyDeviceStatusResult {
    ENABLED = 'ENABLED',
    DISABLED = 'DISABLED',
    UNKNOWN = 'UNKNOWN'
}

export enum PayFullBalanceView {
    INITIAL = 'INITIAL',
    SUCCESS = 'SUCCESS',
    FAILURE = 'FAILURE'
}

export enum BannerAction {
    SCROLL = 'scroll',
    RELOAD = 'reload',
    SCROLL_TO_GTP = 'scroll_to_gtp',
    SCROLL_TO_CANMEX = 'scroll_to_canmex',
    OPEN_MODAL = 'open_modal'
}

export const SECONDARY_BANNER_IDS: string[] = [
    'line.activation.failure',
    'line.order.delivered',
    'line.order.delivered.byodOnly',
    'line.port.failure',
    'line.port.failure.retry'
];

export enum PaymentStoreErrorCode {
    DELETE_TOKEN_FAILED = 'DELETE_TOKEN_FAILED',
    UPDATE_PAYMENT_INSTRUMENT_FAILED = 'UPDATE_PAYMENT_INSTRUMENT_FAILED',
    UPDATE_EXPIRYDATE_FAILED = 'UPDATE_EXPIRYDATE_FAILED'
}

export enum FormNames {
    PAYMENT_AMOUNT = 'paymentAmount',
    ENTER_PAYMENT_AMOUNT = 'enter-payment-amount'
}

export enum DeviceActivationType {
    NEW_PHONE = 'New Phone|[NUMBER_OPTION]',
    TABLET = 'Tablet',
    REPLACEMENT_DEVICE = 'NDEL or Upgrade',
    BYOP = 'BYO Phone|[NUMBER_OPTION]',
    WATCH = 'Pair Watch|[ERRORCPDE]'
}

export enum AnalyticsErrorMessageTemplates {
    UPDATE_CARD_FAILED = 'Error|Update Card',
    UPDATE_CONTACT_INFO_FAILED = 'Error|Update Contact Information',
    ACTIVATION_FAILED = 'Error|Activation|[TYPE]',
    BYO_ACTIVATION_DEVICE_LOCKED = 'Error|Activation|BYO Phone Locked|[ERRORCODE]',
    SUSPEND_LINE_ERROR = 'Error|Suspend Line',
    LEVEL_MOVE_ELIGIBILITY_ERRORS = 'Ineligible|Segment Switch|[ERRORCODE]',
    LEVEL_MOVE_API_ERROR = 'Error|Segment Switch|[ERRORCODE]',
    BUCKET_SWITCH_ERROR = 'Failed|Shared Data Plan Switch',
    PAST_DUE_PAYMENT_FAILED = 'Error|Make a Payment|Past Due',
    PENDING_BALANCE_PAYMENT_FAILED = 'Error|Make a Payment|Pending Balance',
    ADDITIONAL_DEVICE_PAYMENT_FAILED = 'Error|Make a Payment|Additional Device Payment|Device Id: [DEVICEID]',
    PORT_OUT_PIN_GENERATION = 'Error|Port Out Pin Generation',
    REMOVE_DATA_SAVER_FAILED = 'Error|Removing data saver fail',
    ADDING_DATA_SAVER_FAILED = 'Error|Adding data saver fail',
    CANCEL_REMOVING_ADDONS_FAILED = 'Error|Cancel Schedule Addon Remove|[ADDONSTYPE] [ADDONSID] fail',
    REMOVING_ADDONS_FAILED = 'Error|Remove Addons|[ADDONSTYPE] [ADDONSID] fail',
    ADDING_ADDONS_FAILED = 'Error|Adding addons|[ADDONSTYPE] [ADDONSID] fail',
    ADDING_NEW_CARD_FAILED_PENDING_BALANCE = 'Error|Add new card|Pending Balance|Error Code: [ERRORCODE]',
    ADDING_NEW_CARD_FAILED_PAST_DUE = 'Error|Add new card|Past Due|Error Code: [ERRORCODE]',
    BILL_PAYMENT_FAILED_PAST_DUE = 'Error|Bill Payment fail|Past Due|Error Code: [ERRORCODE]',
    ORDER_PAYMENT_FAILED_PAST_DUE = 'Error|Order Payment fail|Past Due|Error Code: [ERRORCODE]',
    ADDING_NEW_CARD_FAILED_ADP = 'Error|Add new card|Additional Device Payment|Device Id: [DEVICEID]',
    QUICK_PAYMENT_LOOKUP_FAILED = 'Error|Quickpay MDN lookup failed|Error Code: [ERRORCODE]',
    QUICK_PAYMENT_FAILED = 'Error|Quickpay payment failed|Error Code: [ERRORCODE]',
    LINE_TRANSFER_REQUEST_PIN_FAILED = 'Error|xmobile|my-account|Request Pin Error modal',
    LINE_TRANSFER_CANCEL_FAILED = 'Error|xmobile|my-account|Cancel Transfer Error modal'
}

export enum SupportDeviceSectionId {
    LG = 'LG',
    APPLE = 'Apple',
    SAMSUNG = 'Samsung',
    GOOGLE = 'google',
    OTHER= 'Other'
}

export enum BreadcrumbLabel {
    BY_THE_GIG = 'By the Gig',
    UNLIMITED = 'Unlimited'
}

export enum PaymentRadioSelector {
    DEFAULT = 'DEFAULT',
    OTHER = 'OTHER'
}

export enum QuickpayLookupErrorCode {
    QP_1000 = 'QP-1000',
    QP_1100 = 'QP-1100',
    QP_1200 = 'QP-1200',
    QP_1300 = 'QP-1300',
    QP_1400 = 'QP-1400',
    QP_1500 = 'QP-1500',
    QP_1700 = 'QP-1700',
    QP_1800 = 'QP-1800',
    QP_1900 = 'QP-1900',
    QP_2000 = 'QP-2000'
}

export enum QuickpayMdnLookupStatus {
    SUCCESS = 'SUCCESS',
    FAILURE = 'FAILURE'
}

export enum QuickpayEmailNotificationStatus {
    NA = 'NA',
    SUCCESS = 'SUCCESS',
    FAILURE = 'FAILURE'
}

export enum ApiSource {
    XOM = 'XOM'
}

export const QUICK_PAYMENT_DEFAULT_REFERRER: string = 'WEB';

export enum BillType {
    PENDING = 'pending',
    PAST_DUE = 'past due'
}

export enum PortFlag {
    YES = 'Y',
    NO = 'N'
}

export enum Frequency {
    MONTHLY = 'MONTHLY',
    DAILY = 'DAILY'
}

export enum FrequencyLabel {
    MONTHLY = 'mo',
    DAILY = 'day'
}

export enum GtpState {
    DEFAULT = 'DEFAULT',
    SELECTED = 'SELECTED',
    ACTIVE = 'ACTIVE',
    ACTIVE_TIMESTAMP = 'ACTIVE_TIMESTAMP',
    REMOVED = 'REMOVED',
    REMOVED_TIMESTAMP = 'REMOVED_TIMESTAMP'
}

export enum GtpSessionState {
    ACTIVE = 'ACTIVE',
    INACTIVE = 'INACTIVE'
}

export enum CanMexCountyCode {
    MEX = 'MEX',
    CAN = 'CAN'
}

export enum LiabilityType {
    BUSINESS_LIABLE = 'BUSINESS_LIABLE',
    PERSONAL_LIABLE = 'PERSONAL_LIABLE'
}

export enum ByodEligibleStatus {
    YES = 'YES',
    NO = 'NO',
    COMPLETED = 'COMPLETED',
    ELIGIBLE = 'ELIGIBLE',
    NOT_ELIGIBLE = 'NOT_ELIGIBLE',
    ERROR = 'ERROR'
}

export const BYOD_INCOMPATIBLE_CODES: string[] = [ 'BYO100', 'BYO400', 'BYO500', 'BYO600', 'BYO700', 'BYO800', 'BYO1000', 'BYO1100', 'BYO1300', 'BYO1500', 'BYO1600', 'BYO1700', 'BYO2500'];
export const BYOD_SOFTWARE_INCOMPATIBLE_CODES: string[] = ['BYO300', 'BYO1200', 'BYO2100'];
export const BYOD_DEVICE_LOCKED_CODES: string[] = ['BYO200', 'BYO1400', 'BYO1900', 'BYO2000'];
export const BYOD_LOST_STOLEN_CODE: string = 'BYO900';
export const PROMO_ROLLCAP_BANNERIDS: string[] = ['account.service.promo.rollcap.pending', 'cb.account.service.promo.rollcap.pending', 'account.service.promo.rollcap.added', 'cb.account.service.promo.rollcap.added'];
export const PROMO_ROLLCAP_BANNERIDS_PENDING: string[] = ['account.service.promo.rollcap.pending', 'cb.account.service.promo.rollcap.pending'];
export const PROMO_ROLLCAP_BANNERIDS_ADDED: string[] = ['account.service.promo.rollcap.added', 'cb.account.service.promo.rollcap.added'];

export enum ESimCapabilityStatus  {
    CONFIRMED = 'CONFIRMED',
    NOT_CONFIRMED = 'NOT_CONFIRMED'
}

export const USAGE_SUMMARY_STATE: string = 'USAGE_SUMMARY_STATE';

export const VERIFICATION_REFERENCE_NUMBER: string = 'VERIFICATION_REFERENCE_NUMBER';

export const FACTORY_RESET: string = 'FACTORY_RESET'; 

export const ESIM_DOWNLOAD_RECHECK_TOTAL_ATTEMPTS: number = 5; 

export const ESIM_DOWNLOAD_RECHECK_INTERVAL: number = 4000; 

export const FEDEX_TRACKING_URL_PREFIX: string = 'https://www.fedex.com/fedextrack/?trknbr=';

export const USPS_TRACKING_URL_PREFIX: string = 'https://tools.usps.com/go/TrackConfirmAction?qtc_tLabels1=';

export const HTTP_PROTOCOL: string = 'http://';

export enum OrderProvisioningStatus {
    PENDING = 'PENDING',
    IN_PROGRESS = 'IN_PROGRESS',
    COMPLETED = 'COMPLETED',
    FAILED = 'FAILED'
}

export enum DeviceSubsidyStatus {
    NEW = 'NEW',
    ACTIVE = 'ACTIVE'
}

export enum TradeInDeviceStatus {
    IN_TRANSIT = 'IN_TRANSIT',
    GOOD_CONDITION = 'GOOD_CONDITION',
    FMIP_ON = 'FMIP_ON',
    REJECTED = 'REJECTED',
    WAITDECISION = 'WAITDECISION',
    PROCESSING = 'PROCESSING',
    RECEIVED = 'RECEIVED',
    COMPLETED = 'COMPLETED',
    NOTRECEIVED = 'NOTRECEIVED',
    ACCEPTED = 'ACCEPTED'
}

export enum TradeInOfferStatus {
    RMA_SET = 'RMA_SET',
    CANCELLED = 'CANCELLED',
    GRACE_PERIOD_EXPIRED = 'GRACE_PERIOD_EXPIRED',
    RMA_EXPIRED = 'RMA_EXPIRED',
    ACCEPTED_DEFERRED = 'ACCEPTED_DEFERRED',
    ACCEPTED = 'ACCEPTED'
}

export enum questionMap{
    DAM_FREE_XF = 'Free of physical damage?',
    LCD_GOOD_XF = 'Free of screen cracks?',
    NO_LIQUID_XF = 'Free of liquid damage?',
    POWER_ON_XF = 'Device powers on?'
}

export enum answerMap{
    DAMF_YES = 'Yes',
    DAMF_NO = 'No',
    LCDG_YES = 'Yes',
    LCDG_NO = 'No',
    NOLIQ_YES = 'Yes',
    NOLIQ_NO = 'No',
    POWER_YES = 'Yes',
    POWER_NO = 'No'
}

export enum UnlOrdersPlanSubgroupType {
    BASIC = 'BASIC',
    PLUS = 'PLUS',
    PREMIUM = 'PREMIUM'
}  

export enum PlanSwitchType {
    INTER_GROUP = 'INTER_GROUP',
    INTRA_UNL_GROUP = 'INTRA_UNL_GROUP',
    INTRA = 'INTRA'
}

export enum PendingLineTransferBanner {
    LINE_PENDING_TRANSFER = 'line.pending.transfer',
    CB_LINE_PENDING_TRANSFER = 'cb.line.pending.transfer',
    CB_ACCOUNT_PENDING_LINE_TRANSFER = 'cb.account.pending.line.transfer',
    ACCOUNT_PENDING_LINE_TRANSFER = 'account.pending.line.transfer'
}

export enum LineTransferModalName {
    REQUEST_NEW_PIN = 'requestNewPin',
    CANCEL_TRANSFER = 'cancelTransfer'
}

export enum UnlPlanSubgroupName {
    INTRO = 'Unlimited Intro',
    PLUS = 'Unlimited Plus',
    PREMIUM = 'Unlimited Premium',
    PREMIUM_FLEX = 'Unlimited Premium Flex',
    TABLET_INTRO = 'Tablet Unlimited Intro',
    TABLET_PREMIUM = 'Tablet Unlimited Premium',
    MOBILE_SELECT = 'Mobile Select',
    MOBILE_PLUS = 'Mobile Plus',
    PRO = 'Pro',
    STANDARD = 'Standard'
}

export enum PlanNames {
    BASIC = 'Unlimited',
    PLUS = 'Unlimited Plus',
    PREMIUM = 'Unlimited Premium',
    PREMIUM_UNLIMITED = 'Premium Unlimited',
    TABLET = 'Tablet Unlimited',
    TABLET_PREMIUM = 'Tablet Premium',
    BY_THE_GIG = 'By the Gig Mobile',
    BY_THE_GIG_SHARED = 'By the Gig',
    SMART_WATCH = 'Smart Watch',
    STANDALONE_SMART_WATCH = 'Standalone Smart Watch',
    MOBILE_SELECT = 'Mobile Select',
    MOBILE_PLUS = 'Mobile Plus',
    PRO = 'Pro',
    STANDARD = 'Standard'
}

export enum UnlPlanSubgroupSeg5 {
    UNLIMITED = 'Unlimited'
}

export enum UserType {
    RESIDENTIAL = 'RESIDENTIAL',
    BUSINESS = 'BUSINESS'
}

export enum ActivationFlowAnalytics {
    BYOD_ACTIVATION_FAILURE = 'byod-activation-failure',
    ACTIVATION_FAILURE = 'activation-failure'
}

export enum CpcSubmitStatus {
    SUCCESS = 'SUCCESS',
    ERROR = 'ERROR'
}

export enum CpcSubmissionActionTaken {
    TOKENIZE = 'tokenize',
    NO_CHANGE = 'no_change'
}

// To fill the CPC with existing card details, we need the Payment Type to be MinCardOnlyWithEdit
export enum CpcTemplateStyles {
    QUICKPAY_PAYMENT_TYPE = 'MinCardOnly',
    UPDATE_CARD_PAYMENT_TYPE = 'MinCardOnlyWithEdit',
    IFRAME_HEIGHT = '880px',
    IFRAME_WIDTH = '100%',
    CPC_PAGE_LABEL_CASE = 'CapOnlyFirst',
    CPC_HOST_APP_URL = 'integration',
    IFRAME_BORDER = 'none'
}

export enum CpcCase {
    CPC_CONFIG_READY = 'CPC_CONFIG_READY',
    CPC_CONFIG_SUBMIT = 'CPC_CONFIG_SUBMIT',
    CPC_FORM_SUBMIT_RESPONSE = 'CPC_FORM_SUBMIT_RESPONSE',
    CPC_FORM_SUBMIT = 'CPC_FORM_SUBMIT',
    CPC_ERROR = 'CPC_ERROR',
    CPC_INFO_EVENT = 'CPC_INFO_EVENT',
    CPC_FORM_PROCESSING = 'CPC_FORM_PROCESSING',
    CPC_LOADING = 'CPC_LOADING',
    CPC_NETWORK_INFO = 'CPC_NETWORK_INFO'
}

export enum CpcCustomerClass {
    BUSINESS_MOBILE = 'BUSINESS_MOBILE',
    RESIDENTIAL_MOBILE = 'RESIDENTIAL_MOBILE'
}

export enum CpcDetails {
    SOURCE_SYSTEM_ID_SUFFIX = '_CPC',
    JUMP_WEB_COMPONENT = 'jump-web-component',
    IFRAME = 'iframe',
    COMCAST = 'Comcast',
    MESSAGE_DISPLAY_LOCATION = 'top',
    TOKENIZE = 'tokenize',
    UPDATE = 'update'
}

export enum MinimumPayment {
    AMOUNT = 9,
    MINIMUM_PAYMENT = 'minimum-payment'
}

export enum DiscountPromoScope {
    DEVICE = 'DEVICE',
    LINE = 'LINE',
    ACCOUNT = 'ACCOUNT'
}

export enum PromoStatus {
    NEW = 'NEW', // MCXW-9389: Backend ticket OTB-4619 says could be PENDING instead of NEW
    ACTIVE = 'ACTIVE',
    INACTIVE = 'INACTIVE'
}

export enum PromoAction {
    ORDERED = 'ORDERED',
    ACTIVATED = 'ACTIVATED',
    LINE_TRANSFERRED = 'LINE_TRANSFERRED',
    LINE_CEASED = 'LINE_CEASED',
    PLAN_CHANGED = 'PLAN_CHANGED'
}

export enum TradeInProgram {
    UPGRADE = 'UPGRADE',
    TIP = 'TIP',
    ITI = 'ITI'
}

export enum AccountLevelFee {
    TABLET_ONLY_FEE ='Tablet-Only Fee',
    XM_ONLY_FEE = 'XM-Only Fee'
}

export enum FCC_BROADBAND_FOOTER {
    READ_MORE = 'Read more',
    READ_LESS = 'Read less'
}

export enum INSURANCE_PLAN_NAME {
    ACTIVE_PLAN = 'ACTIVE',
    XTDP = 'XTDP - Xfinity Total Device Protection',
    XTDP_PLUS = 'XTDP - Xfinity Total Device Protection Plus'
}

export enum DeferredPorting {
    PORT_IN_RESOLUTION_REQUIRED = 'PORT_IN_RESOLUTION_REQUIRED',
    PORT_IN_PROGRESS = 'PORT_IN_PROGRESS',
    PORT_IN_CONFIRMED = 'PORT_IN_CONFIRMED',
    PORT_IN_DELAY = 'PORT_IN_DELAY',
    DEFERRED_PORT_IN = 'DEFERRED_PORT_IN'
}

export enum DeferredPortingStatus {
    READY_FOR_TRANSFER = 'READY_FOR_TRANSFER',
    IN_PROGRESS = 'IN_PROGRESS',
    ERROR = 'ERROR'
}

export enum PILL_STATUS {
    SUCCESS = 'success',
    FAILED = 'failed',
    PENDING = 'pending'
}

export enum BillingBreadCrumb {
    STATEMENT = 'Statement',
    ESTIMATED = 'Current Cycle',
    NEXT_BILL_ESTIMATE = 'Next Bill Estimate',
    ORDER = 'Order'
}

export enum GlobalTravelPassTabName {
    GLOBAL = 'GLOBAL',
    MEXICO_CANADA = 'MEXICO_CANADA',
    INTERNATIONAL = 'international'
}

export enum GlobalTravelPassLineStatus {
    IN_USE = 'In use',
    INCLUDED = 'Included',
    OFF = 'Off',
    PENDING = 'Pending',
    SELECTED = 'Selected',
    PENDING_REMOVAL = 'Pending Removal'
}

export enum BannerLocation {
    BILLING = 'billing',
    ACTIVITY_BTG_LINES = 'activityBtgLines',
    BTG_UNL_PLANSWITCH_START = 'btgToUnlplanSwitchStart',
    UNL_BTG_PLANSWITCH_START = 'unlToBtgPlanSwitchStart',
    MANAGE_UNL_PLANSWITCH_START = 'manageUnlPlanSwitchStart',
    UNL_BTG_PLANSWITCH_SUCCESS = 'unlToBtgPlanSwitchSuccess',
    SEGMENT_SWITCH = 'segmentSwitch',
    SEGMENT_SWTITCH_SUMMARY = 'segmentSwitchSummary',
    SEGMENT_SWITCH_START = 'segSwitchStart',
    SEGMENT_SWITCH_CONFIRM = 'segSwitchConfirm',
    BTG_LINE_DETAILS = 'btgLineDetails',
    XM_PORTOUT ='xmPortOut'
}

export enum BannerId{
    CB4_PLUS_LINES_DISCOUNT = 'cb4PlusLinesDiscount'
}

export enum PromoType {
    LOSS = 'loss',
    KEEP = 'keep',
    ELIGIBLE = 'eligible'
}

export enum stateURLs {
    segmentChangeURL = 'account.settings.level-move.landing'
}

export enum oddDeliveryStatus {
    DRIVER_ON_THE_WAY_TO_CUSTOMER = 'DRIVER_ON_THE_WAY_TO_CUSTOMER',
    DRIVER_ARRIVED_AT_DESTINATION = 'DRIVER_ARRIVED_AT_DESTINATION',
    ORDER_ACCEPTED = 'ORDER_ACCEPTED',
    DRIVER_ACCEPTED = 'DRIVER_ACCEPTED',
    ROUTE_PLAN_UPDATED = 'ROUTE_PLAN_UPDATED',
    DRIVER_ON_THE_WAY_TO_STORE = 'DRIVER_ON_THE_WAY_TO_STORE',
    DRIVER_ARRIVED_AT_PICKUP_STORE = 'DRIVER_ARRIVED_AT_PICKUP_STORE',
    ODD_ORDER_CANCELLED = 'ODD_ORDER_CANCELLED',
    ORDER_NOT_ACCEPTED = 'ORDER_NOT_ACCEPTED',
    ORDER_DELIVERED = 'DELIVERED',
    ORDER_CANCELED = 'CANCELED',
    SHARED_LOCATION = 'SHARED_LOCATION'
}

export enum DeviceModel {
    IPHONE_18_PRO_MAX_MODEL = 'iphone 18 pro max'
}
